import { DOMAIN_CONFIGS } from '@/configs';
import { getStorageKey } from '@/utils';

/**
 * 默认币种
 * @returns
 */
export const getDefaultCurrency = () => {
  const currency: string =
    localStorage.getItem(getStorageKey('currency')) || DOMAIN_CONFIGS.SINOMOTIVE.defaults.currency;
  return currency;
};
